// Mock data for Iron Crust Gym - Indore

export const GYM_INFO = {
  name: "Iron Crust Gym",
  tagline: "Build Real Strength. Create Your Best Body.",
  location: "Vijay Nagar, Indore, Madhya Pradesh",
  whatsapp: "+918357015066",
  whatsappLink: "https://wa.me/918357015066",
};

// Supplement Products with EXACT uploaded image URLs
export const SUPPLEMENTS = [
  {
    id: 1,
    name: "Fast&Up BCAA",
    image: "https://customer-assets.emergentagent.com/job_9718953c-79dc-42d0-b140-1e4544c60161/artifacts/c45xtlh3_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2001_24_56%20PM.png",
    benefits: ["Boosts Endurance", "Reduces Fatigue", "Supports Recovery"],
    price: 1499,
    description: "Intra-training BCAA formula with 30 servings",
  },
  {
    id: 2,
    name: "RICP Omega 3 Fish Oil",
    image: "https://customer-assets.emergentagent.com/job_9718953c-79dc-42d0-b140-1e4544c60161/artifacts/t7zsxcan_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2001_25_55%20PM.png",
    benefits: ["4X Strength", "No Fishy Burps", "EPA & DHA Rich"],
    price: 999,
    description: "1650mg Omega 3 per serving, 60 softgels",
  },
  {
    id: 3,
    name: "MuscleBlaze Biozyme Performance Whey",
    image: "https://customer-assets.emergentagent.com/job_9718953c-79dc-42d0-b140-1e4544c60161/artifacts/39nfweg6_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2001_27_43%20PM.png",
    benefits: ["Enhanced Absorption", "Muscle Support & Recovery", "Clinically Tested"],
    price: 2499,
    description: "750g premium whey with superior absorption",
  },
  {
    id: 4,
    name: "Optimum Nutrition Gold Standard Whey",
    image: "https://customer-assets.emergentagent.com/job_9718953c-79dc-42d0-b140-1e4544c60161/artifacts/3tmbi61m_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_17_19%20PM.png",
    benefits: ["24g Protein", "5.5g BCAAs", "Double Rich Chocolate"],
    price: 4999,
    description: "4kg world's best-selling whey protein",
  },
  {
    id: 5,
    name: "BigMuscles Karnage Pre-Workout",
    image: "https://customer-assets.emergentagent.com/job_9718953c-79dc-42d0-b140-1e4544c60161/artifacts/l7wdrbzn_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_21_52%20PM.png",
    benefits: ["Explosive Energy", "Intense Focus", "Extreme Pumps"],
    price: 1799,
    description: "King of Pre-Workouts - 300g intense formula",
  },
  {
    id: 6,
    name: "ON Micronised Creatine",
    image: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/a4m7ltnx_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_19_48%20PM.png",
    benefits: ["100% Pure", "Performance Support", "Raining Tested"],
    price: 1299,
    description: "250g micronised creatine monohydrate",
  },
];

// Gym Interior Images
export const GYM_IMAGES = {
  heroGym: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/gfhn9do7_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_16_48%20PM.png",
  equipmentArea: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/hc9hah4f_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_16_53%20PM.png",
  treadmillCorridor: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/aqzk0d5l_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_16_56%20PM.png",
  luxuryGym: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/q2q0xo86_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_16_56%20PM.png",
  sunsetCardio: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/0cau9elm_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_17_00%20PM.png",
  functionalArea: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/nd54qocm_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_17_03%20PM.png",
};

// Training & People Images
export const TRAINING_IMAGES = {
  personalTraining: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/qj40ybom_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2002_23_32%20PM.png",
  athleteTraining: "https://customer-assets.emergentagent.com/job_gym-masters-3/artifacts/xn0f5jel_gettyimages-1988004616-2048x2048.jpg",
};

// Membership Plans
export const MEMBERSHIPS = [
  {
    id: 1,
    name: "Monthly",
    price: 2499,
    duration: "1 Month",
    features: [
      "Full Gym Access",
      "Locker Facility",
      "Cardio & Strength Equipment",
      "Hygiene Maintained",
    ],
    badge: null,
  },
  {
    id: 2,
    name: "Quarterly",
    price: 6499,
    duration: "3 Months",
    features: [
      "Full Gym Access",
      "Locker Facility",
      "Cardio & Strength Equipment",
      "Diet Consultation",
      "Progress Tracking",
    ],
    badge: "Most Popular",
  },
  {
    id: 3,
    name: "Annual",
    price: 19999,
    duration: "12 Months",
    features: [
      "Full Gym Access",
      "Priority Locker",
      "All Equipment Access",
      "Free Personal Training (1 Session)",
      "Nutrition Consultation",
      "Free Shaker Bottle",
    ],
    badge: "Best Value",
  },
];

// Personal Training Programs
export const PERSONAL_TRAINING = [
  {
    id: 1,
    name: "In-Gym 1-on-1 Training",
    price: 8999,
    duration: "1 Month (12 Sessions)",
    description: "Dedicated personal trainer for customized workout plans",
    features: [
      "12 Personal Training Sessions",
      "Custom Workout Plan",
      "Form Correction & Technique",
      "Progress Tracking",
    ],
  },
  {
    id: 2,
    name: "Online Coaching",
    price: 4999,
    duration: "1 Month",
    description: "Remote coaching with video analysis and daily check-ins",
    features: [
      "Personalized Training Plan",
      "Weekly Video Calls",
      "Daily WhatsApp Support",
      "Nutrition Guidance",
    ],
  },
  {
    id: 3,
    name: "Competition Prep",
    price: 29999,
    duration: "3 Months",
    description: "Elite coaching for bodybuilding/powerlifting competitions",
    features: [
      "Intensive Training Program",
      "Peak Week Strategy",
      "Stage Presentation Coaching",
      "Complete Nutrition Plan",
    ],
  },
];

// Strength Programs
export const STRENGTH_PROGRAMS = [
  {
    id: 1,
    name: "Powerlifting Program",
    price: 7999,
    duration: "8 Weeks",
    description: "Build maximum strength in squat, bench, and deadlift",
    features: [
      "Progressive Overload Protocol",
      "Competition-Style Training",
      "Strength Testing",
      "Accessory Work Included",
    ],
  },
  {
    id: 2,
    name: "Hypertrophy Program",
    price: 6999,
    duration: "12 Weeks",
    description: "Muscle building focused program for maximum size gains",
    features: [
      "Volume-Based Training",
      "Muscle Group Specialization",
      "Body Composition Tracking",
      "Supplement Guidance",
    ],
  },
  {
    id: 3,
    name: "Functional Strength",
    price: 5999,
    duration: "8 Weeks",
    description: "Real-world strength for athletic performance",
    features: [
      "Movement-Based Training",
      "Mobility & Flexibility Work",
      "Injury Prevention",
      "Sports Performance Enhancement",
    ],
  },
];

// Fat Loss Programs
export const FAT_LOSS_PROGRAMS = [
  {
    id: 1,
    name: "Beginner Fat Burn",
    price: 5999,
    duration: "8 Weeks",
    description: "Perfect starting point for weight loss journey",
    features: [
      "Low-Impact Cardio",
      "Basic Strength Training",
      "Simple Nutrition Plan",
      "Weekly Check-ins",
    ],
  },
  {
    id: 2,
    name: "Advanced Shred",
    price: 8999,
    duration: "12 Weeks",
    description: "Aggressive fat loss while maintaining muscle",
    features: [
      "HIIT & Metabolic Conditioning",
      "Heavy Lifting Program",
      "Macro-Based Diet Plan",
      "Body Fat Testing",
    ],
  },
  {
    id: 3,
    name: "90-Day Transformation",
    price: 14999,
    duration: "90 Days",
    description: "Complete body recomposition program",
    features: [
      "Full Training & Diet Plan",
      "Weekly Personal Training",
      "Progress Photos & Tracking",
      "Supplement Protocol",
    ],
  },
];

// Testimonials & Transformations
export const TESTIMONIALS = [
  {
    id: 1,
    name: "Rahul Sharma",
    result: "Lost 18kg in 4 months",
    rating: 5,
    text: "Iron Crust Gym ne meri life badal di! Coaches bohot supportive hain aur equipment world-class hai. Highly recommend!",
    beforeImage: null,
    afterImage: null,
  },
  {
    id: 2,
    name: "Arjun Patel",
    result: "Gained 12kg muscle mass",
    rating: 5,
    text: "Best gym in Indore! Personal training program se mere strength aur physique mein remarkable improvement hua. Worth every rupee!",
    beforeImage: null,
    afterImage: null,
  },
  {
    id: 3,
    name: "Vikram Singh",
    result: "Body fat 22% to 12%",
    rating: 5,
    text: "Authentic supplements aur expert guidance - dono ek jagah milte hain. Iron Crust is the real deal for serious lifters.",
    beforeImage: null,
    afterImage: null,
  },
  {
    id: 4,
    name: "Karan Mehta",
    result: "Deadlift 80kg to 160kg",
    rating: 5,
    text: "Strength program se meri lifts double ho gayi! Coaching quality aur gym atmosphere ekdum top-notch hai.",
    beforeImage: null,
    afterImage: null,
  },
];

// Why Choose Iron Crust
export const WHY_CHOOSE_US = [
  {
    id: 1,
    title: "Certified Coaches",
    description: "Expert trainers with proven track records",
  },
  {
    id: 2,
    title: "Premium Equipment",
    description: "Imported machines & free weights",
  },
  {
    id: 3,
    title: "Spotless Hygiene",
    description: "Daily sanitization & maintenance",
  },
  {
    id: 4,
    title: "Custom Nutrition",
    description: "Personalized diet plans for your goals",
  },
  {
    id: 5,
    title: "24/7 Support",
    description: "Always available on WhatsApp",
  },
  {
    id: 6,
    title: "Results Guaranteed",
    description: "500+ successful transformations",
  },
];
